import { createTheme, MantineColorsTuple } from '@mantine/core';

// Mantine wants a 10-step tuple per color. Anchor 6 is the "primary" shade adset.pro uses.
const brandBlue: MantineColorsTuple = [
  '#eef4ff', '#dbe6ff', '#b3c8ff', '#85a8ff', '#5a8cff',
  '#3d78ff', '#2d6cff', '#1f5beb', '#1450d3', '#0044bb',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 5 },
  colors: { brand: brandBlue },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '700',
  },
  defaultRadius: 'md',
  radius: { xs: '4px', sm: '6px', md: '8px', lg: '12px', xl: '16px' },
  shadows: {
    xs: '0 1px 2px rgba(15,23,42,0.04)',
    sm: '0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04)',
    md: '0 4px 12px rgba(15,23,42,0.06), 0 2px 4px rgba(15,23,42,0.04)',
    lg: '0 12px 28px rgba(15,23,42,0.08), 0 4px 8px rgba(15,23,42,0.05)',
  },
  components: {
    Card: { defaultProps: { withBorder: true, shadow: 'sm', radius: 'lg', padding: 'lg' } },
    Button: { defaultProps: { radius: 'md' } },
    Paper: { defaultProps: { withBorder: true, radius: 'lg' } },
  },
});
